import { WMItemDpLookupLayout, WMRoleLayout, WMTransactionDPLookupLayout, } from '../../../../common/lookups/Layouts/WMLayouts';

const TransctionLayout = [
    {
        "groupId": 1,
        "label": "Receipt Transaction Number",
        "fields": [
            {
                "name": "ReceiptTransactionNumber",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "R",
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Shipment Transaction Number",
        "fields": [
            {
                "name": "ShipmentTransactionNumber",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "S",
            },
        ]
    },
    {
        "groupId": 3,
        "label": "Adjustment Transaction Number",
        "fields": [
            {
                "name": "AdjustmentTransactionNumber",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "A",
            },
        ]
    },
]
const ItemsLayout = [
    {
        "groupId": 1,
        "label": "Lot Code Generation",
        "fields": [
            {
                "name": "LotCodeGeneration",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "L",
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Sublot Code Generation",
        "fields": [
            {
                "name": "SublotCodeGeneration",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "B",
            },
        ]
    },
    {
        "groupId": 3,
        "label": "Unit Code Generation",
        "fields": [
            {
                "name": "UnitCodeGeneration",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "U",
            },
        ]
    },
]
const MiscLayout = [
    {
        "groupId": 1,
        "label": "Transaction # Generation",
        "fields": [
            {
                "name": "TransactionGeneration",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "M",
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Storage Transaction Number",
        "fields": [
            {
                "name": "StorageTransactionNumber",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "C",
            },
        ]
    },
    {
        "groupId": 3,
        "label": "Invoice # Generation",
        "fields": [
            {
                "name": "InvoiceGeneration",     
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "I",
            },
        ]
    },
]
const ShipperConsigneeLayout = [
    {
        "groupId": 1,
        "label": "Consignee Id Generation",
        "fields": [
            {
                "name": "ReceiptTransactionNumber",
                
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "V",
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Serial No - Outbound",
        "fields": [
            {
                "name": "ShipmentTransactionNumber",
                
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "K",
            },
        ]
    }
]
const SerialLayout = [
    {
        "groupId": 1,
        "label": "Serial # Generation",
        "fields": [
            {
                "name": "SerialGeneration",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "E",
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Physical Count # Generation",
        "fields": [
            {
                "name": "PhysicalCountGeneration",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "H",
            },
        ]
    },
    {
        "groupId": 3,
        "label": "SSCC # Generation",
        "fields": [
            {
                "name": "SSCCGeneration",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "N",
            },
        ]
    },
]
const OwnershipTransferLayout = [

    {
        "groupId": 1,
        "label": "Sublot Alternate ID",
        "fields": [
            {
                "name": "SublotAlternateID",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "D",
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Crate # Generation",
        "fields": [
            {
                "name": "CrateGeneration",              
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "F",
            },
        ]
    },
        {
        "groupId": 3,
        "label": "Ownership Transfer Rec/Ship Profiles",
        "fields": [
            {
                "name": "R_RECEIPTPROFILE",
                "tableName": "WMSETUP",
                "label": "Receipt Profile",
                "type": "lookup",
                "layout": WMTransactionDPLookupLayout,
                "lookupDisplayMode":"grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_SHIPMENTPROFILE",
                "tableName": "WMSETUP",
                "label": "Shipment Profile",
                "type": "lookup",
                "layout": WMTransactionDPLookupLayout,
                "lookupDisplayMode":"grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]}
]
const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "EDI/Handheld Profile",
        "fields": [
            {
                "name": "R_TRANSACTIONPROFILE",
                "tableName": "WMSETUP",
                "label": "Transaction",
                "type": "lookup",
                "layout": WMTransactionDPLookupLayout,
                "lookupDisplayMode":"grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_ITEMPROFILE",
                "tableName": "WMSETUP",
                "label": "Item",
                "type": "lookup",
                "layout": WMItemDpLookupLayout,
                "lookupDisplayMode":"grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Lot & Sublot Selection",
        "fields": [
            {
                "name": "SHOWCURRENTLOTONLY",
                "tableName": "WMSETUP",
                "label": "Lot",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SHOWCURRENTSUBLOTONLY",
                "tableName": "WMSETUP",
                "label": "Sublot",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Item Status",
        "fields": [
            {
                "name": "UPDATEITEMSTATUS",
                "tableName": "WMSETUP",
                "label": "Update Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Conversion Factors",
        "fields": [
            {
                "name": "STDTOMETRICTONCONVERSIONFACTOR",
                "tableName": "WMSETUP",
                "label": "Matric Ton",
                "type": "number", "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const TransactionEntryLayout = [
    {
        "groupId": 1,
        "label": "Transaction Entry - Visible Tabs",
        "fields": [
            {
                "name": "SCHEDULE",
                "tableName": "WMSETUP",
                "label": "Scheduling",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSPORTATION",
                "tableName": "WMSETUP",
                "label": "Transportation",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LABORTRACKING",
                "tableName": "WMSETUP",
                "label": "Labor Track",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINED",
                "tableName": "WMSETUP",
                "label": "User Defined",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CURRENCY",
                "tableName": "WMSETUP",
                "label": "Currency",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSCHARGES",
                "tableName": "WMSETUP",
                "label": "Trans Charges",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PALLETTRACKING",
                "tableName": "WMSETUP",
                "label": "Pallet Tracking",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "APIMSGS",
                "tableName": "WMSETUP",
                "label": "API Msgs",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RFAUDITMSGS",
                "tableName": "WMSETUP",
                "label": "RF Audit Msgs",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "INSPECTION",
                "tableName": "WMSETUP",
                "label": "Inspection",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CANCELLEDITEMS",
                "tableName": "WMSETUP",
                "label": "Cancelled Items",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ITEMLOTUPDATE",
                "tableName": "WMSETUP",
                "label": "Lot Update",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Bill of Lading",
        "fields": [
            {
                "name": "BillofLading",
                "type": "transNumSetup","successMessage":"Setup Updated Successfully",
                "visible": true,
                "module": "WM",
                "transactionType": "G",
            },
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CREATETRANSACTIONCHARGES",
                "tableName": "WMSETUP",
                "label": "Trans Charges",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UPDATESTAGEFLD",
                "tableName": "WMSETUP",
                "label": "Update Stage",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ScheduleRole",
                "tableName": "WMSETUP",
                "label": "Schedule Role",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "ProShip",
        "fields": [
            {
                "name": "OTCREATEITEMFROMPROFILE",
                "tableName": "WMSETUP",
                "label": "Create Items",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNCOMMITMAXLIMIT",
                "tableName": "WMSETUP",
                "label": "Un Commit Max",
                "type": "number",
                 "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
                        {
                "name": "PROSHIPEXEPATH",
                "tableName": "WMSETUP",
                "label": "Ex Path",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PROSHIPPRINTER",
                "tableName": "WMSETUP",
                "label": "Printer",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
        {
        "groupId": 5,
        "label": "Stage Security",
        "fields": [
            {
                "name": "STAGEUPSECURITY",
                "tableName": "WMSETUP",
                "label": "Stage Up",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STAGEDOWNSECURITY",
                "tableName": "WMSETUP",
                "label": "Stage Down",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
]
export {
    TransctionLayout,
    PrimaryLayout,
    ItemsLayout,
    MiscLayout,
    ShipperConsigneeLayout,
    SerialLayout,
    OwnershipTransferLayout,
    TransactionEntryLayout
}